export interface NavItem {
  path: string;
  label: string;
  icon: string;
  /** Permission keys: at least one must be present to show this item. */
  permisosRequeridos?: string[];
}

/**
 * Filters nav items by the user's permission set.
 * Items without `permisosRequeridos` are always visible (e.g. Dashboard).
 * Items with `permisosRequeridos` are visible if at least one required
 * permission is present in the permisos set.
 */
export function filterNavItems(
  items: NavItem[],
  permisos: Set<string>,
): NavItem[] {
  return items.filter((item) => {
    if (!item.permisosRequeridos) return true;
    return item.permisosRequeridos.some((p) => permisos.has(p));
  });
}

/** Si tiene al menos uno de los permisos ("modulo:accion"): p. ej. Mantenimiento se abre con remitos:ver o wms:ver. */
export function tieneAlguno(permisos: string[], can: (modulo: string, accion: string) => boolean): boolean {
  return permisos.some((p) => {
    const [modulo, accion] = p.split(':');
    return can(modulo, accion);
  });
}
